import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

import {TranslateService} from "@ngx-translate/core";

import {sendSurveyRequestModel} from '@survey/models/send-survey-request.model';
import {SurveyHttpService} from "@survey/services/survey-http.service";
import {SurveyDisplayService} from "@survey/services/survey-display.service";

@Component({
  selector: 'surveym-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.less']
})
export class SurveyComponent {

  isLoading = false;
  rating = 0;
  review = '';
  surveySent = false;
  isLowRatingReasonsVisible = false;
  selectedReasons = '';

  afterPositiveReviewMessage = '';
  afterNegativeReviewMessage = '';

  get reviewPlaceholder(): string {
    return this.rating > 2 ? this.afterPositiveReviewMessage : this.afterNegativeReviewMessage;
  }

  get isRatingSelected(): boolean {
    return this.rating > 0;
  }

  constructor(
    private dialogRef: MatDialogRef<SurveyComponent>,
    private surveyHttpService: SurveyHttpService,
    private surveyDisplayService: SurveyDisplayService,
    private translateService: TranslateService
  ) {
     this.translateService.get('survey.after-positive-review').subscribe(t => this.afterPositiveReviewMessage = t);
      this.translateService.get('survey.after-negative-review').subscribe(t => this.afterNegativeReviewMessage = t);
  }

  onSend() {
    this.isLoading = true;
    this.sendSurvey(false);
  }

  onRatingChanged(starIndex: number) {
    this.rating = starIndex;
    this.isLowRatingReasonsVisible = this.rating <= 2;
  }

  onClose() {
    this.sendSurvey(false, true);
    this.dialogRef.close();
  }

  onCloseAfterSent() {
    this.dialogRef.close();
  }

  onSelectedReasonsChanged(selectedReasons: string) {
    this.selectedReasons = selectedReasons;
  }

  private sendSurvey(firstTimeSendJustRating: boolean, surveyClosed = false) {
    this.surveyHttpService.createSurveyInDb().subscribe(() => {
      const request = this.getSendSurveyRequest(firstTimeSendJustRating, surveyClosed);
      this.surveyHttpService.sendSurvey(request).subscribe({
        next: (x) => { this.afterSendSurvey(firstTimeSendJustRating, surveyClosed); },
        error: () => this.afterSendSurvey(firstTimeSendJustRating, surveyClosed) //udajemy że wszystko poszło jak trzeba
      });
    });
  }

  private getSendSurveyRequest(firstTimeSendJustRating: boolean, surveyClosed: boolean) {
    //api ma walidację ratingu i wartość 10 jest tylko po to żeby móc wysłać poprawny request do api z informacją że ankieta została zamknięta
    const fakeRating = 10;

    const request: sendSurveyRequestModel = {
      rating: surveyClosed ? fakeRating : this.rating,
      review: firstTimeSendJustRating ? '' : this.getFullReview(surveyClosed)
    };
    return request
  }

  private afterSendSurvey(firstTimeSendJustRating: boolean, surveyClosed = false) {
    this.isLoading = false;

    if (!firstTimeSendJustRating && !surveyClosed) {
      this.surveyDisplayService.saveSurveySentDate();
      this.surveySent = true;
    }
  }

  private getFullReview(surveyClosed = false): string {
    let fullReview = '';

    if (surveyClosed)
      fullReview += 'ANKIETA ZAMKNIĘTA';

    if (this.rating <= 2)
      fullReview += this.selectedReasons;

    if (this.review.length > 0)
      fullReview += ' KOMENTARZ: ' + this.review;

    return fullReview;
  }

}
